import { styled } from '@mui/material/styles';

export const Actions = styled('div')`
  min-height: 30px;
`;

export const Wrapper = styled('div')`
  margin-bottom: 1rem;
`;
